import { Box, Grid, TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Status } from './types.ts';
import { CreateDateTimePickerComponentProps } from './types.ts';

export const CreateDateTimePickerComponent = ({
  data,
}: {
  data: CreateDateTimePickerComponentProps;
}) => {
  const {
    status,
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
  } = data;

  const announcement = (
    <Grid item xs={12}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Box display="flex" gridGap={16}>
          <TextField
            type="datetime-local"
            id="maintenance-start-date"
            label="Start date"
            value={startDate}
            onChange={handleStartDateChange}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            type="datetime-local"
            id="maintenance-end-date"
            label="End date"
            value={endDate}
            onChange={handleEndDateChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </MuiPickersUtilsProvider>
    </Grid>
  );

  const started = (
    <Grid item xs={12}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Box display="flex" gridGap={16}>
          <TextField
            type="datetime-local"
            id="maintenance-estimated-end-date"
            label="Estimated end date"
            value={endDate}
            onChange={handleEndDateChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </MuiPickersUtilsProvider>
    </Grid>
  );

  switch (status) {
    case Status.Announcement:
      return announcement;
    case Status.Started:
      return started;
    default:
      return null;
  }
};
